import { Progress, Typography } from "@material-tailwind/react";
import "./index.css";
import { useEffect } from "react";

const TestSetLoader = ({ total, current }) => {
    return (
        <div className="w-4/5 fixed bottom-20 glassmorphic-bg">
            <span className="font-bold">Saving the Testing in DataBase</span>
            <div className="flex items-center justify-between gap-4 mb-2 transform ">
                <Typography color="blue" variant="h6">Completed</Typography>
                <Typography color="blue" variant="h6">{Math.ceil((current * 100) / (total))}%</Typography>
            </div>
            <Progress value={Math.ceil((current * 100) / (total))} className="transform" />
        </div>
    );
}
export default TestSetLoader;